const ITEMS = ["We Pump", "We Blow", "We Go", "When needed, we'll be there"];

function Track({ ariaHidden }) {
  return (
    <div
      aria-hidden={ariaHidden || undefined}
      className="marquee-track flex shrink-0 items-center gap-10 pr-10"
    >
      {ITEMS.map((item) => (
        <span
          key={item}
          className="flex items-center gap-10 whitespace-nowrap font-display text-2xl font-bold uppercase tracking-wide text-black sm:text-3xl"
        >
          {item}
          <span className="inline-block h-3 w-3 rotate-45 bg-black" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="marquee-band" className="overflow-x-clip py-2">
      <div className="-rotate-1 border-y-4 border-black bg-[#0052FF] py-4 shadow-[0_0_60px_rgba(0,82,255,0.35)]">
        <div className="marquee flex overflow-hidden">
          <Track />
          <Track ariaHidden />
        </div>
      </div>
    </div>
  );
}